const DITypes = {
  JsonRpcDispatcher: Symbol('DmPortalDmPortalJsonRpcDispatcher'),
  DispatcherFactory: Symbol('DmPortalDmPortalDispatcherFactory'),
  AdapterFactory: Symbol('DmPortalDmPortalAdapterFactory'),
};

export default DITypes;
